export const state = () => ({
  apps: [],
  members: []
});

export const mutations = {
  SET_APPS: function (state, apps) {
    state.apps = apps;
  },
  SET_MEMBERS: function (state, members) {
    state.members = members;
  }
};
export const actions = {
  fetchApps({ dispatch, state, commit }) {
    const id = $nuxt.$ls.get("selected-location-id");
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`/apps`, {
          params: { location_id: id },
          ...$nuxt.$configData?.apiV2Config
        })
        .then(function (response) {
          commit("SET_APPS", response.data);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  subscribeApp({ dispatch, state, commit }, appId) {
    const id = $nuxt.$ls.get("selected-location-id");
    return new Promise((resolve, reject) => {
      this.$axios
        .post(
          `/linked_apps/subscribe`,
          { location_id: id, app_id: appId },
          $nuxt.$configData?.apiV2Config
        )
        .then(function (response) {
          $nuxt.$store.dispatch("restaurant/getLocationLinkedApps");
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  unSubscribeApp({ dispatch, state, commit }, appId) {
    const id = $nuxt.$ls.get("selected-location-id");
    return new Promise((resolve, reject) => {
      this.$axios
        .post(
          `/restaurants/${appId}/app_subscribe`,
          { location_id: id, app_id: appId },
          $nuxt.$configData?.apiV2Config
        )
        .then(function (response) {
          $nuxt.$store.dispatch("restaurant/getLocationLinkedApps");
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  fetchMembers({ commit }, appId) {
    const id = $nuxt.$ls.get("selected-restaurant-id");
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`/linked_apps/${appId}/team_members`, {
          linked_apps: { roles: null },
          ...$nuxt.$configData?.apiV2Config
        })
        .then(function (response) {
          commit("SET_MEMBERS", response.data.team_members);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  addMember({ dispatch }, { appId, formData }) {
    const id = $nuxt.$ls.get("selected-restaurant-id");
    return new Promise((resolve, reject) => {
      this.$axios
        .post(`/restaurants/${id}/linked_apps/${appId}/add-member`, formData)
        .then(function (response) {
          dispatch("fetchMember");
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  }
};
export const getters = {
  showSpinner: (state) => state.showSpinner,
  getRecommendedApps(state) {
    return state.apps.filter((item) => {
      return true;
    });
  },
  getDefaultApps(state) {
    const DEFAULT_APPS = ["menu"];
    return state.apps.filter((item) => {
      return DEFAULT_APPS.indexOf(item.identifier) >= 0;
    });
  },
  getMyApps(state) {
    return (
      state.apps.filter((item) => {
        return $nuxt.$store.state.restaurant.linkedApps?.find((app) => {
          return app.status == 2 && app.source == item.identifier;
        });
      }) || []
    );
  },
  getApp(state) {
    return (id) => {
      return state.apps.find((item) => {
        return item.id == id;
      });
    };
  }
};
